import { isMobile } from 'react-device-detect'

export function MobileAssistantFormPowered(){

    if(!isMobile) return null
    
    return <img src='/assets/images/wourage.png' width={100}/>

}